import React from "react";
import "./Header.css";
import { Container } from "react-bootstrap";
import filtrix from "../../../../assets/Images/svg/Filtrix final.svg";

const Header = ({ url, section }) => {

  const { about_description, about_image, about_button, contact_button, question_text, contact_phone } = section.data;
  return (
    <div className="about-header">
      <img className="filtrix-img" src={url + "/" + about_image} />
      <div className="about-text"> {about_description}
      </div>
      <div className="find-device">
        <button onClick={() => window.location.href = "/products"} className="about-device-btn">{about_button}</button>
        <button onClick={() => window.location.href = "/contact"} className="about-contact-btn">{contact_button}</button>
      </div>
      <div className="about-line"></div>
      <div className="about-sub-text">{question_text}
        {/* Have any questions? <br/> Contact us! */}
      </div>
      <div className="cotact-number">{contact_phone}
      </div>
    </div>
  );
};

export default Header;
